import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DocumentDataImageModel} from '../../main-interface/controls/tdo-organizer/models/document-data-image.model';
import {FileManagerService} from '../../modules/file-manager/file-manager.service';
import {DocumentInFolderDataModel} from '../../models/document/document-in-folder-data.model';
import {GetDocumentThumbnailModel} from '../../main-interface/controls/tdo-organizer/models/get-document-thumbnail.model';
import {TdoImageGridComponent} from '../../tdo-controls/common/tdo-image-grid/tdo-image-grid.component';
import {ITdoImageGridItem} from '../../tdo-controls/common/tdo-image-grid/models/i-tdo-image-grid-item';
import {TdoImageGridContextModel} from '../../tdo-controls/common/tdo-image-grid/models/tdo-image-grid-context.model';
import {ClaimStatusEnum} from '../../models/enum/claim-status.enum';
import {ClaimMethodEnum} from '../../models/enum/notification/claim-method.enum';
import {ARService} from '../../modules/ar/ar.service';
import {DataARClaimAttachmentModel} from '../../models/accountsReceivable/data-ar-claim-attachments.model';
import {DatePipe} from '@angular/common';
import {LabelResponseModel} from '../../models/labels/label-response.model';
import {DocumentFileTypeEnum} from '../../models/enum/document/document-file-type.enum';
import {DocumentDataModel} from '../../models/document/document-data.model';

@Component({
  selector: 'app-image-picker-dialog',
  templateUrl: './image-picker-dialog.component.html',
  styleUrls: ['./image-picker-dialog.component.scss']
})
export class ImagePickerDialogComponent implements OnInit {

  @ViewChild('tdoImageGrid') imageGrid: TdoImageGridComponent;

  ARClaimID: string;
  patientId: string;
  descriptions: LabelResponseModel[] = [];
  disabledIDs: LabelResponseModel[] = [];
  checkedIDsAdded: LabelResponseModel[] = [];
  checkedIDsSent: LabelResponseModel[] = [];
  attachments: DataARClaimAttachmentModel[];
  thumbnailImages: DocumentDataImageModel[];
  images: DocumentInFolderDataModel[] = [];
  // images: DocumentDataModel[] = [];
  imagesFiltered: DocumentInFolderDataModel[] = [];
  // imagesFiltered: DocumentDataModel[] = [];
  selectedImages: DocumentInFolderDataModel[] = [];
  isImagesLoading = false;
  isShowPublish = false;
  isAscending = false;
  thumbnailImageSize = 150;

  enumClaimAttachmentStatusAdded: string = '00000541-1000-0000-0000-000000000001';
  enumClaimAttachmentStatusSent: string = '00000541-1000-0000-0000-000000000002';
  enumClaimAttachmentTypeDocument: string = '00000542-1000-0000-0000-000000000001';
  enumClaimAttachmentTypeNarrative: string = '00000542-1000-0000-0000-000000000002';

  enumDocumentFileTypeID: string = '0000001B-1000-0000-0000-000000000003';

  constructor(
    public dialogRef: MatDialogRef<ImagePickerDialogComponent>,
    public fileManagerService: FileManagerService,
    private fileService: FileManagerService,
    private arService: ARService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  async ngOnInit() {

    this.patientId = this.data.PatientId;
    this.ARClaimID = this.data.ARClaimID;

    // if claimid exists, load rest of component
    if (this.ARClaimID) {

      const model = new GetDocumentThumbnailModel();
      model.patientId = this.patientId;
      model.type = 13; // claim attachments

      // get claim data
      const promises: any[] = [
        this.fileManagerService.getDocumentThumbnailsClaimAttachments(model).toPromise(),
        this.arService.getClaimAttachements(this.ARClaimID).toPromise(),
      ];

      const results: any[] = await Promise.all(promises);
      this.images = results[0];
      this.attachments = results[1];
      this.imagesFiltered = this.images;
      this.thumbnailImages = [];
      this.isImagesLoading = false;
      this.mapThumbnails();

      // loop through thumbnails and add status descriptions
      this.thumbnailImages.forEach(a => {
        const desc: LabelResponseModel = new LabelResponseModel();
        this.attachments.forEach(b => {
          if (a.model.DocumentID === b.dataDocument.DocumentID) {
            if (b.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusSent) {
              const dis: LabelResponseModel = new LabelResponseModel();
              const ckd: LabelResponseModel = new LabelResponseModel();
              dis.objectId = a.model.DocumentID;
              desc.objectId = a.model.DocumentID;
              ckd.objectId = a.model.DocumentID;
              desc.contentHtml = 'Sent: ' + this.datePipe.transform(b.StatusOn, 'dd-MM-yyyy');
              a.description = 'Sent: ' + this.datePipe.transform(b.StatusOn, 'dd-MM-yyyy');
              ckd.checked = true;
              this.disabledIDs.push(dis);
              this.checkedIDsSent.push(ckd);
            }
            if (b.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusAdded) {
              const dis: LabelResponseModel = new LabelResponseModel();
              const ckd: LabelResponseModel = new LabelResponseModel();
              dis.objectId = a.model.DocumentID;
              desc.objectId = a.model.DocumentID;
              ckd.objectId = a.model.DocumentID;
              desc.contentHtml = 'Added: ' + this.datePipe.transform(b.StatusOn, 'dd-MM-yyyy');
              a.description = 'Added: ' + this.datePipe.transform(b.StatusOn, 'dd-MM-yyyy');

              this.checkedIDsAdded.push(ckd);
            }
          }
        });

        // add filename for description
        if (a.model) {
          desc.objectId = a.model.DocumentID;
          if (a.model.dataDocument.Description) {
            desc.contentHtml += '<br/>' + a.model.dataDocument.Description;
          }
          else if (a.model.dataDocument.PhysicalFileName) {
            desc.contentHtml += '<br/>' + a.model.dataDocument.PhysicalFileName;
          }
        }
        this.descriptions.push(desc);
      });
    }
  }

  // async ngOnInit(): {
  //
  //   // // get claim data
  //   // const promises: any[] = [
  //   //   this.arService.getClaimItemList(this.ARClaimID).toPromise(),
  //   // this.arService.getClaimAttachements(this.ARClaimID).toPromise(),
  //   // this.arService.getClaimDetails(this.ARClaimID).toPromise(),
  //   // ];
  //   //
  //   // const results: any[] = await Promise.all(promises);
  //   // this.dataClaimItems = results[0];
  //   // this.dataClaimAttachments = results[1];
  //   // this.dataClaim = results[2];
  //
  //   if (this.data && this.data.PatientId) {
  //     this.patientId = this.data.PatientId;
  //     const model = new GetDocumentThumbnailModel();
  //     model.patientId = this.patientId;
  //     model.type = -1;
  //
  //     this.fileManagerService.getDocumentThumbnails(model).subscribe((res) => {
  //       this.images = res;
  //       this.thumbnailImages = [];
  //
  //       this.isImagesLoading = false;
  //       this.mapThumbnails();
  //     });
  //   }
  // }

  mapThumbnails() {
    this.thumbnailImages = this.imagesFiltered.map( (o) => {
      const model = new DocumentDataImageModel();
      model.imageSource = this.fileService.getDocumentUrlFromDocument(o.dataDocument);
      model.model = Object.assign(o);
      return model;
    });
    this.isImagesLoading = false;
    if (this.imageGrid) {
      this.imageGrid.forceUpdate(this.thumbnailImages);
    }
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  onOkClick() {
    this.dialogRef.close(this.selectedImages);
  }

  onGridItemsSelected(event: ITdoImageGridItem[]) {
    this.selectedImages = event.map(p => p.model as DocumentInFolderDataModel);
    return this.selectedImages;
  }

  onGridBackgroundContextMenu($event: MouseEvent) {

  }

  onGridContextMenu($event: TdoImageGridContextModel) {

  }
}
